import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class FaviconService {

  setFavicon(iconUrl: string): void {
    let link: HTMLLinkElement | null =
      document.querySelector("link[rel*='icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.type = 'image/x-icon';
    link.href = `${iconUrl}?v=${Date.now()}`;

  }
}
